(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.capital-at-risk', [
    'pp.widgets-templates',
    'pp.services.route'
]);

ngModule.component('ppCapitalAtRisk', {
    templateUrl: 'widgets/_angular/capital-at-risk/capital-at-risk.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', 'routeService', function ($scope, routeService) {
        var vm = this;

        // -- initial state

        vm.keyRisksUrl = routeService.keyRisksUrl;

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);